<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady && notification !== null">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{notification.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs8>
        <v-layout column>
          <v-flex>

              <v-layout row class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <v-avatar
                      :tile="false"
                      :size="72"
                      color="grey lighten-4"
                      class="mr-3 float-left"
                  >
                    <img :src="notification.author_user.photo.url_resized" alt="avatar">
                  </v-avatar>
                  <div>
                    <p class="title mt-2">{{notification.author_user.surname + ' ' + notification.author_user.first_name + ' ' + notification.author_user.patronymic}}</p>
                    <p class="body-2 mt-3">{{notification.author_user.user_group.title}}</p>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout class="elevation-1 white mb-4 pa-3">
                <v-flex xs6>
                  <div>
                    <span class="title">Дата создания: </span>
                    <span class="title font-weight-thin">{{ $moment(notification.created_datetime).format('D MMM YYYY, HH:mm') }}</span>
                  </div>

                  <div v-if="notification.branch !== null">
                    <div v-if="notification.branch.id !== 0" class="mt-1">
                      <span class="title">Филиал: </span>
                      <span class="title font-weight-thin">{{notification.branch === null ? 'Все филиалы' : notification.branch.title}}</span>
                    </div>
                    <div v-if="notification.sale_group !== null" class="mt-1">
                      <span class="title">Супервайзер: </span>
                      <span class="title font-weight-thin">{{notification.sale_group.title}}</span>
                    </div>
                    <div v-if="notification.user_group !== null" class="mt-1">
                      <span class="title">Группа пользователей: </span>
                      <span class="title font-weight-thin">{{notification.user_group.title}}</span>
                    </div>
                  </div>
                </v-flex>
              </v-layout>

              <p class="title">Описание</p>
              <v-layout row class="elevation-1 white mb-4 pa-3">
                <v-flex xs8>
                  <div class="text-xs-left subheading">{{notification.description}}</div>
                </v-flex>
              </v-layout>

              <p class="text-xs-left title" v-if="statistics !== null">Статистика</p>
              <v-layout row class="elevation-1 white mb-4 pa-3" v-if="statistics !== null">
                <v-flex xs12>
                  <v-list two-line class="statistics-list">
                    <template v-for="(item, index) in statistics.option_list">
                      <v-list-tile :key="index" avatar ripple @click="getAnswersByOption(item.id)">
                        <div class="statistics-item-indicator" :style="'width: ' + item.percent + '%'"></div>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-list-tile-action-text>{{ item.percent }}% ({{ item.answer_stat[item.answer_stat.length - 1] > 0 ? item.answer_stat[item.answer_stat.length - 1].count : 0 }})</v-list-tile-action-text>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider v-if="index + 1 < statistics.option_list.length" :key="`divider-${index}`"></v-divider>
                    </template>
                  </v-list>


                  <div class="mt-3">
                    <v-data-table
                        :headers="statisticsHeaders"
                        :items="answers"
                        hide-actions
                        class="elevation-1"
                        no-data-text="Не найдено ни одного ответа"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip bottom>
                          <span slot="activator">
                            {{ props.header.text }}
                          </span>
                          <span>
                            {{ props.header.text }}
                          </span>
                        </v-tooltip>
                      </template>
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">
                          <v-avatar class="my-2">
                            <img :src="props.item.user.photo.url_resized">
                          </v-avatar>
                        </td>
                        <td class="text-xs-left">{{ props.item.user.surname }} {{ props.item.user.first_name }} {{ props.item.user.patronymic }}</td>
                        <td class="text-xs-left">{{ $moment(props.item.datetime).calendar() }}</td>
                      </template>
                    </v-data-table>
                  </div>

                </v-flex>
              </v-layout>

              <p class="text-xs-left title" v-if="statistics !== null">График ответов</p>
              <v-layout row v-if="statistics !== null" class="elevation-1 white mb-4 pa-3">
                <v-flex xs12>
                  <line-chart :data="chartData" :dataset="{steppedLine: true}"></line-chart>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-0 mt-5">
                <v-flex xs6>
                  <p class="title">Дата и время рассылки</p>
                  <v-time-picker
                      format="24hr"
                      class="ml-0 mb-0 notification-page-send-time"
                      :value="$moment(notification.planned_send_datetime).format('HH:mm')"
                  ></v-time-picker>
                </v-flex>
              </v-layout>

              <v-layout row class="mb-4 mt-0">
                <v-flex xs6>
                  <v-date-picker
                      class="mt-0"
                      locale="ru"
                      readonly
                      :value="$moment(notification.planned_send_datetime).format('YYYY-MM-DD')"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </v-flex>
              </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editNotification(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить уведомление?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteNotificationConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Сообщения', link: '/notifications/future'}
        ],
        statisticsHeaders: [
          { text: 'Фото', sortable: false, value: 'avatar' },
          { text: 'ФИО', sortable: false, value: 'name' },
          { text: 'Дата и время ответа', sortable: false, value: 'datetime' }
        ],
        answers: [],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        chartData: [],
        id: null,
        pageDataReady: {
          isReady: false,
          notification: false,
          statistics: false
        },
        deleteDialog: false
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getNotificationSingle', {id: this.$route.params.id})
        .then(() => {
          this.pageDataReady.notification = true
          this.pageDataStatus()
        })
      this.$store.dispatch('getNotificationStatistics', {id: this.$route.params.id})
        .then(() => {
          this.pageDataReady.statistics = true
          this.pageDataStatus()
        })
    },
    computed: {
      notification () {
        return this.$store.getters.notificationSingle
      },
      statistics () {
        return this.$store.getters.notificationStatistics
      }
    },
    methods: {
      editNotification (id) {
        this.$router.push('/notifications/edit/' + id)
      },
      deleteNotificationConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteNotification', {id: this.id})
        this.$router.push('/notifications/future/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.notification) {
          return false
        }
        if (!this.pageDataReady.statistics) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      getAnswersByOption (id) {
        for (let i = 0; i < this.statistics.option_list.length; i++) {
          if (this.statistics.option_list[i].id === id) {
            this.answers = []
            // this.chartData = {}
            for (let k = 0; k < this.statistics.option_list[i].answer_list.length; k++) {
              this.answers.push(this.statistics.option_list[i].answer_list[k])
            }
            // for (let k = 0; k < this.statistics.option_list[i].answer_stat.length; k++) {
            //   this.chartData[this.statistics.option_list[i].answer_stat[k].date] = this.statistics.option_list[i].answer_stat[k].count
            // }
            break
          }
        }
      }
    },
    watch: {
      notification (val) {
        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Сообщения', link: '/notifications/future'}
        ]
        this.breadcrumbs.push({name: this.notification.title})
        this.$store.commit('setPageTitle', this.notification.title)

        this.id = this.notification.id
        if (this.notification.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        this.actions.canUpdate = this.notification.can_update
        this.actions.canRemove = this.notification.can_remove
      },
      statistics (val) {
        console.log(this.statistics)
        if (this.statistics.answer_total_count > 0) {
          for (let i = 0; i < this.statistics.option_list.length; i++) {
            for (let k = 0; k < this.statistics.option_list[i].answer_list.length; k++) {
              this.answers.push(this.statistics.option_list[i].answer_list[k])
            }
            this.chartData.push({name: this.statistics.option_list[i].title, data: {}})
            for (let k = 0; k < this.statistics.option_list[i].answer_stat.length; k++) {
              if (typeof this.chartData[this.chartData.length - 1].data[this.statistics.option_list[i].answer_stat[k].date] !== 'undefined') {
                this.chartData[this.chartData.length - 1].data[this.statistics.option_list[i].answer_stat[k].date] += this.statistics.option_list[i].answer_stat[k].count
              } else {
                this.chartData[this.chartData.length - 1].data[this.statistics.option_list[i].answer_stat[k].date] = this.statistics.option_list[i].answer_stat[k].count
              }
            }
          }
        } else {
          this.answers = []
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Notifications/NotificationSingle.vue